<template>
  <div>
    <view-options elementId="GoogleDisplay" />
    <div class="product-view" id="GoogleDisplay">
      <div>
        <div class="lds-ellipsis" v-if="loadingData">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <h3 class="widget-title">
          ¿Qué logró su publicidad digital en Campañas de generación de demanda
          en Google?
        </h3>
        <div class="two-column">
          <div>
            <section class="widget widget-goals">
              <div class="cards-wrapper">
                <card type="goals">
                  <div class="card-header">
                    <div class="icon-wrapper">
                      <font-awesome-icon icon="eye" />
                    </div>
                    <h4 class="card-title">Impresiones</h4>
                  </div>
                  <div class="card-content">
                    <h1>{{ numberLetter(productData.totalImpressions) }}</h1>
                    <p>
                      Cantidad de veces que su publicidad fue expuesta a su
                      público objetivo
                    </p>
                  </div>
                </card>
                <card type="goals">
                  <div class="card-header">
                    <div class="icon-wrapper">
                      <font-awesome-icon icon="mouse-pointer" />
                    </div>
                    <h4 class="card-title">Clicks</h4>
                  </div>
                  <div class="card-content">
                    <h1>{{ numberLetter(productData.totalClicks) }}</h1>
                    <p>Interacciones con su audiencia</p>
                  </div>
                </card>
              </div>
            </section>
            <section class="widget brand-impact">
              <h3 class="widget-title">El impacto de su marca en el tiempo</h3>
              <card type="line-chart">
                <div class="card-top">
                  <div class="card-header">
                    <h4 class="card-title">Impresiones</h4>
                  </div>
                </div>
                <div class="card-content">
                  <impressions
                    :totalImpressions="Product.totalImpressions || 0"
                    :impressions="Product.impressions || []"
                    :clicks="Product.clicks || []"
                    :imp="impressionsChartOptions"
                    :labelType="'Clicks'"
                  ></impressions>
                </div>
              </card>
            </section>
          </div>

          <mq-layout mq="laptop+">
            <section class="mobile-canvas">
              <img src="@/assets/images/google-discovery-phone.png" alt />
            </section>
          </mq-layout>
        </div>
      </div>
      <section class="widget campaign-widget">
        <h3 class="widget-title">Campañas</h3>
        <card>
          <table class="table">
            <thead>
              <th class="table-left" title="Campaña">Campaña</th>
              <th title="Impresiones">Impresiones</th>
              <th title="Clicks">Clicks</th>
              <th title="CTR">CTR</th>
              <th title="Conversiones" v-if="businessUnit == 2">
                Conversiones
              </th>
              <th title="CPC">CPC</th>
            </thead>
            <tbody>
              <tr v-for="(campaignData, index) in campaignData" :key="index">
                <td class="table-left">{{ campaignData.name }}</td>
                <td>{{ Number(campaignData.impressions).toLocaleString() }}</td>
                <td>{{ Number(campaignData.clicks).toLocaleString() }}</td>
                <td>{{ campaignData.ctr.toFixed(2) }}%</td>
                <td v-if="businessUnit == 2">
                  {{ campaignData.conversions.toFixed(2) }}
                </td>
                <td>${{ campaignData.cpm.toFixed(2) }}</td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <th class="table-left">Total</th>
                <th>{{ TotalCampains.Impresiones.toLocaleString() }}</th>
                <th>{{ TotalCampains.Clicks.toLocaleString() }}</th>
                <th>{{ TotalCampains.CTR.toFixed(2).toLocaleString() }}%</th>
                <th v-if="businessUnit == 2">
                  {{ TotalCampains.Conversions.toFixed(2) }}
                </th>
                <th>${{ TotalCampains.CPC.toFixed(2).toLocaleString() }}</th>
              </tr>
            </tfoot>
          </table>
        </card>
      </section>

      <section
        v-if="AllConversionActions.length"
        class="widget campaign-widget"
      >
        <h3 class="widget-title">Resumen de Conversions</h3>
        <conversion-table :conversionArray="AllConversionActions" />
      </section>

      <div class="widget-area audience-report one-column">
        <section class="widget">
          <h3 class="widget-title">Interacción de sus audiencias</h3>
          <card>
            <apexchart
              type="pie"
              width="380"
              :options="audienceInteractionChartOptions"
              :series="audienceInteractionSeries"
            />
          </card>
          <p style="font-style: italic;">
            Se muestran los resultados de mayor volumen con un límite de 5
            elementos
          </p>
        </section>
      </div>
      <div class="widget-area demographic-data">
        <h3 class="widget-title">Datos demográficos sobre sus usuarios</h3>
        <section class="widget">
          <h5 class="widget-title">Edad</h5>
          <card>
            <ApexchartBar
              type="bar"
              height="350"
              :headers="genderChartOptions.xaxis.categories"
              :series="genderSeries[0].data"
              :bar="true"
            />
          </card>
        </section>

        <section class="widget">
          <h5 class="widget-title">Género</h5>
          <card>
            <ApexchartBar
              type="bar"
              height="350"
              :headers="ageChartOptions.xaxis.categories"
              :series="ageSeries[0].data"
              :bar="true"
            />
          </card>
        </section>
        <section class="widget">
          <h5 class="widget-title">Dispositivos</h5>
          <card>
            <ApexchartBar
              type="bar"
              height="350"
              :headers="devicesChartOptions.xaxis.categories"
              :series="devicesSeries[0].data"
              :bar="false"
            />
          </card>
        </section>
      </div>
    </div>
    <div class="export" id="export"></div>
  </div>
</template>
<script>
import ViewOptions from "@/components/ViewOptions.vue";
import Impressions from "@/components/ApexchartCustom/Impressions.vue";
import ApexchartBar from "../../components/ApexchartCustom/ApexchartBar";
import { mapGetters } from "vuex";
import img from "../../assets/images/logoGenerico.png";
import ConversionTable from "../../components/ConversionTable";

// REQUEST
import adwordsGoogleDiscovery from "../../services/Fase2/adwordGoogleDiscovery";
import { validateProductExpirationDate } from "../../util";

export default {
  name: "google-discovery",
  components: {
    ViewOptions,
    Impressions,
    ApexchartBar,
    ConversionTable
  },
  data() {
    return {
      ConversionActions: [],
      AllConversionActions: [],
      businessUnit: 1,
      showMessage: false,
      loadingData: false,
      mas: 8,
      Message: "más +",
      Product: [],
      TotalCampains: {
        Impresiones: 0,
        Clicks: 0,
        CTR: 0,
        CPC: 0,
        Conversions: 0,
        GmailSaves: 0,
        GmailForwards: 0,
        GmailSecondaryClicks: 0
      },
      productData: {
        totalImpressions: 0,
        totalClicks: 0
      },
      keywordData: [
        {
          keyword: "ventana",
          impressions: 212575,
          clicks: 2212
        },
        {
          keyword: "Cristales",
          impressions: 199977,
          clicks: 1538
        },
        {
          keyword: "Enmarcados",
          impressions: 179328,
          clicks: 94
        },
        {
          keyword: "construccion en republica dominicana",
          impressions: 65232,
          clicks: 542
        },
        {
          keyword: "Grabados",
          impressions: 26463,
          clicks: 723
        }
      ],
      adSites: [],
      campaignData: [],
      impressionsSeries: [
        {
          name: "Impresiones",
          data: []
        },
        {
          name: "Clicks",
          data: []
        }
      ],
      PRimpressionsSeries: [
        {
          name: "Impresiones",
          data: []
        }
      ],
      impressionsChartOptions: {
        tooltip: {
          x: {
            show: true,
            format: "dd MMM",
            formatter: undefined
          },

          y: {
            formatter: function(value) {
              return value.toLocaleString();
            }
          }
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ],
        chart: {
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          // width: [5, 7, 5],
          curve: "smooth"
        },
        markers: {
          size: 0,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          categories: [
            "Jun '18",
            "Ago '18",
            "Oct '18",
            "Dic '18",
            "Feb '18",
            "Abr '18"
          ]
        },
        grid: {
          borderColor: "#f1f1f1"
        }
      },
      audienceInteractionSeries: [],
      audienceInteractionChartOptions: {
        colors: [
          "#0A286E",
          "#0E3593",
          "#1248C9",
          "#3772FF",
          "#08ACFF",
          "#93ABE6",
          "#BECDF0"
        ],
        labels: [],
        legend: {
          position: "bottom"
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ]
      },
      interestTopicsSeries: [],
      interestTopicsChartOptions: {
        colors: [
          "#0A286E",
          "#0E3593",
          "#1248C9",
          "#3772FF",
          "#08ACFF",
          "#93ABE6",
          "#BECDF0"
        ],
        labels: [],
        legend: {
          position: "bottom"
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ]
      },
      genderSeries: [
        {
          data: []
        }
      ],
      genderChartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      ageSeries: [
        {
          data: []
        }
      ],
      ageChartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      devicesSeries: [
        {
          data: []
        }
      ],
      devicesChartOptions: {
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      adsBanners: [],
      adBannerImages: [],
      index: null
    };
  },
  watch: {
    date1: {
      handler() {
        this.reload(this);
      },
      deep: true
    },

    date2: {
      handler() {
        this.reload(this);
      },
      deep: true
    }
  },
  async created() {
    const context = this;
    this.reload(context);
  },

  methods: {
    CHANGE_IMAGE(e) {
      e.target.src = img;
    },
    reload: async function(context) {
      this.loadingData = true;
      context.productData.totalImpressions = 0;
      context.productData.totalClicks = 0;

      context.ageSeries[0].data = [];
      context.genderSeries[0].data = [];
      context.devicesSeries[0].data = [];

      context.ageChartOptions.xaxis.categories = [];
      context.genderChartOptions.xaxis.categories = [];
      context.devicesChartOptions.xaxis.categories = [];

      context.TotalCampains.Impresiones = 0;
      context.TotalCampains.Clicks = 0;
      context.TotalCampains.CTR = 0;
      context.TotalCampains.CPC = 0;
      context.TotalCampains.Conversions = 0;
      context.TotalCampains.GmailSaves = 0;
      context.TotalCampains.GmailForwards = 0;
      context.TotalCampains.GmailSecondaryClicks = 0;
      context.campaignData = [];
      context.audienceInteractionSeries = [];

      const { businessUnitId, subscriberId, productId } = context.$route.params;
      const { customerId } = context.$route.query;

      const products = context.$store.state.subscriber.products;
      const validatedFinalDate = validateProductExpirationDate(
        products,
        productId,
        context.$store.state.subscriber.date1
      );

      let fromDate =
        context.$store.state.subscriber.date2 > validatedFinalDate
          ? validatedFinalDate
          : context.$store.state.subscriber.date2;
      let toDate = validatedFinalDate;

      context.businessUnit = businessUnitId;
      const objCampaigns = [];
      const objAdSites = [];
      const objAdsBanners = [];
      const product = {
        clicks: [],
        impressions: [],
        totalImpressions: 0
      };

      const googleDiscovery = await new adwordsGoogleDiscovery(
        context
      ).getGoogleDiscovery(
        subscriberId,
        businessUnitId,
        fromDate,
        toDate,
        customerId
      );

      this.loadingData = false;

      const conversionActions = [];

      context.ConversionActions = googleDiscovery.conversionActions;

      if (context.ConversionActions.length > 0) {
        context.ConversionActions.map(({ conversionActionRows }) => {
          return conversionActionRows.map(actions => {
            conversionActions.push({
              allConversion: actions.allConversion,
              conversionAction: actions.conversionAction
            });
          });
        });
      }

      context.AllConversionActions = conversionActions;

      context.productData.totalImpressions += googleDiscovery.totalImpressions;
      context.productData.totalClicks += googleDiscovery.totalClicks;

      // impressions and clicks
      googleDiscovery.impressionsAndClicks.forEach(element => {
        context.impressionsSeries[0].data.push(element.impressions);
        context.impressionsSeries[1].data.push(element.clicks);
        context.impressionsChartOptions.xaxis.categories.push(element.date);

        product.clicks.push({ count: element.clicks, date: element.date });
        product.impressions.push({
          count: element.impressions,
          date: element.date
        });
      });

      // age
      (googleDiscovery.ages || []).forEach(element => {
        if (element.criteria) {
          context.ageChartOptions.xaxis.categories.push(element.criteria);
          context.ageSeries[0].data.push(element.impressions);
        }
      });

      // gender
      (googleDiscovery.genders || []).forEach(element => {
        if (element.criteria) {
          const filterCriteria = element.criteria.replace("to", " to ");
          context.genderChartOptions.xaxis.categories.push(filterCriteria);
          context.genderSeries[0].data.push(element.impressions);
        }
      });
      //DEVICE
      (googleDiscovery.devices || []).forEach(element => {
        if (element.criteria) {
          if (element.criteria.includes("Devices")) {
            context.devicesChartOptions.xaxis.categories.push("TV");
          } else {
            context.devicesChartOptions.xaxis.categories.push(
              element.criteria.split(" ")[0]
            );
          }
          context.devicesSeries[0].data.push(element.impressions);
        }
      });
      // CAMPAIGN
      (googleDiscovery.campaigns || []).forEach(element => {
        objCampaigns.push({
          name: element.campaignname,
          impressions: element.impressions,
          clicks: element.clicks,
          ctr: element.ctr,
          cpm: element.cpc,
          conversions: element.conversions,
          gmailSaves: element.gmailSaves,
          gmailForwards: element.gmailForwards,
          gmailSecondaryClicks: element.gmailSecondaryClicks
        });
        context.TotalCampains.Conversions += element.conversions;
        context.TotalCampains.GmailForwards += element.gmailForwards;
        context.TotalCampains.GmailSaves += element.gmailSaves;
        context.TotalCampains.GmailSecondaryClicks +=
          element.gmailSecondaryClicks;
      });

      // AUDIENCE
      googleDiscovery.audiences = googleDiscovery.audiences.sort(
        (a, b) => b.impressions - a.impressions
      );

      googleDiscovery.audiences.splice(0, 5).forEach(element => {
        context.audienceInteractionSeries.push(element.impressions);
        context.audienceInteractionChartOptions.labels.push(element.criteria);
      });

      context.TotalCampains.Impresiones = googleDiscovery.totalImpressions;
      context.TotalCampains.Clicks = googleDiscovery.totalClicks;
      context.TotalCampains.CTR = googleDiscovery.totalCtr;
      context.TotalCampains.CPC = googleDiscovery.totalCpc;

      //ADS
      (googleDiscovery.ads || []).forEach(element => {
        objAdsBanners.push({
          bannerURL: element.imageadurl,
          itemCode: "300 x 250"
        });
        context.adBannerImages.push(element.imageadurl);
      });

      context.campaignData = objCampaigns;
      context.adSites = objAdSites;

      context.adsBanners = objAdsBanners;
      context.Product = product;

      if (context.adSites.length > 8) {
        context.showMessage = true;
      }
    },

    numberLetter(value) {
      let suffixes = [
        "U",
        "D",
        "C",
        "K",
        "K",
        "K",
        "M",
        "M",
        "M",
        "B",
        "B",
        "B",
        "T",
        "T",
        "T"
      ];

      let stringValue = value.toString();
      let valueLength = stringValue.length;
      let suffix = suffixes[valueLength - 1];

      const BASEDIVISOR = 3;
      let startindex = 0;
      let characterToTake = valueLength % BASEDIVISOR;
      characterToTake = characterToTake == 0 ? BASEDIVISOR : characterToTake;

      if (valueLength > BASEDIVISOR) {
        let wholePart = stringValue.substr(startindex, characterToTake);
        let decimalPart = stringValue.substr(
          startindex + characterToTake,
          BASEDIVISOR
        );

        let firstDecimal = decimalPart.substr(startindex, 1);

        let wholeNumber =
          firstDecimal != "0"
            ? wholePart + "." + decimalPart.substr(startindex, 1) + suffix
            : wholePart + suffix;

        return wholeNumber;
      }

      return stringValue;
    },

    collapse() {
      if (this.mas === 8) {
        this.mas = 80;
        this.Message = "menos -";
      } else if (this.mas > 9) {
        this.mas = 8;
        this.Message = "más +";
      }
    }
  },
  computed: {
    ...mapGetters(["date1", "date2", "products"])
  }
};
</script>
<style lang="scss" scoped>
.table {
  thead th {
    text-align: center;
  }
}
.export {
  display: none;
}
.nameSite {
  white-space: nowrap;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.show {
  background: linear-gradient(0deg, #fff, #fff 70%, hsla(0, 0%, 100%, 0));
  color: $link-color;
  font-size: 12px;
  margin: 0 45%;
}
.invisible-col-group {
  background: white;
  border-top: 0;
  border-left: 0;
}
.table-left {
  border-left: 2px solid #dee4ed;
}
.logo {
  width: 106px;
  height: 50px;
}
.product-view {
  .two-column {
    display: grid;
  }
}
.ad-sites-wrapper {
  text-align: center;
  .sites {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid $blueish-gray-200;
    &:last-child {
      margin-bottom: 0px;
      padding-bottom: 0px;
      border-bottom: none;
    }
    h4 {
      color: $blueish-gray-700;
    }
    .site-data {
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin-top: 15px;
      h6 {
        color: $blueish-gray-600;
      }
      p {
        color: $blueish-gray-400;
      }
    }
  }
}

.widget {
  &.widget-goals {
    .card-goals {
      .card-content {
        text-align: center;
        h1 {
          span {
            font-size: 35px;
          }
          font-size: 52px;
          font-weight: $font-medium;

          color: $highlight-color;
        }
      }
    }
  }
  &.brand-impact {
    .card-line-chart {
      .card-top {
        .card-number {
          text-align: center;
          h3 {
            color: $highlight-color;
          }
        }
      }
    }
  }
}

@include respond-above(sm) {
  .ad-sites-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    .sites {
      .site-data {
        margin-top: 5px;
      }
    }
  }
  .widget {
    &.widget-goals {
      .cards-wrapper {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 20px;
      }
    }
  }
}

.demographic-data {
  margin-top: 30px;
  h5 {
    font-size: 16px;
    color: $blueish-gray-600;
  }
}

@include respond-above(md) {
  .product-view {
    // display: grid;
    // grid-template: 1fr auto / 1fr minmax(300px, 350px);
    // grid-column-gap: 30px;
    max-width: 1000px;
    margin: 0 auto;
    .two-column {
      grid-column: 1 / -1;
      grid-template-columns: 2fr 1fr;
      grid-column-gap: 20px;
    }
    .widget-look {
      grid-row: 1 / -1;
      grid-column: 2;
    }
    .widget {
      &.keyword-widget,
      &.campaign-widget,
      &.ad-sites-widget {
        grid-column: 1 / -1;
      }
    }
    .separator {
      grid-column: 1 / -1;
      margin-bottom: 20px;
    }
    .demographic-data {
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 30px;
      & > .widget-title {
        text-align: center;
        grid-column: 1 / -1;
        margin-bottom: 30px;
      }
      .widget:nth-child(4) {
        grid-column: 1 / -1;
      }
    }
    .ad-views {
      grid-column: 1 / -1;
      .cards-wrapper {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 30px;
      }
    }
  }
  .ad-sites-wrapper {
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 20px;
    .sites {
      border-right: 1px solid $blueish-gray-200;
      border-bottom: none;
      padding-bottom: 0px;

      &:nth-child(4n) {
        border-right: none;
      }
    }
  }
}

// loading

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #3576ff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
</style>
